import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import SettingsIcon from '@mui/icons-material/Settings';
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';
import StopIcon from '@mui/icons-material/Stop';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import Stack from '@mui/material/Stack';
import React from 'react';
import { LabeledButton } from '../../../common/LabeledButton';
import { usePracticeContext } from '../../context/PracticeContext';
import { texts } from '../intl';
export function Actions() {
    const { practiceMode, clockState } = usePracticeContext();
    /*
        view:
            left: settings
            main: record
            right: preview

        recording:
            left: settings - disabled
            main: restart
            right: stop

        replay:
            left: settings - disabled
            main: record - disabled
            right: stop

        demo:
            left: settings - disabled
            main: record
            right: stop
     */
    switch (practiceMode) {
        case 'recording':
            return React.createElement(RecordingActions, null);
        case 'evaluate':
            return React.createElement(EvaluateActions, null);
        case 'demo':
            return React.createElement(DemoActions, null);
        // case 'replay':
        //     return <ReplayActions/>
        default:
            return React.createElement(ViewActions, null);
    }
}
function RecordingActions() {
    const { actions: { restartRecording, stopRecording } } = usePracticeContext();
    return React.createElement(Stack, { className: "Actions" },
        React.createElement(SecondaryAction, { label: texts.actions.settings, disabled: true },
            React.createElement(SettingsIcon, null)),
        React.createElement(PrimaryAction, { label: texts.actions.restart, onClick: restartRecording },
            React.createElement(SettingsBackupRestoreIcon, null)),
        React.createElement(SecondaryAction, { label: texts.actions.stop, onClick: stopRecording },
            React.createElement(StopIcon, null)));
}
function DemoActions() {
    const { actions: { startRecording, stopDemo } } = usePracticeContext();
    return React.createElement(Stack, { className: "Actions" },
        React.createElement(SecondaryAction, { label: texts.actions.settings, disabled: true },
            React.createElement(SettingsIcon, null)),
        React.createElement(PrimaryAction, { label: texts.actions.play, onClick: startRecording },
            React.createElement(PlayArrowIcon, null)),
        React.createElement(SecondaryAction, { label: texts.actions.stop, onClick: stopDemo },
            React.createElement(StopIcon, null)));
}
function ViewActions() {
    const { actions: { startRecording, startDemo } } = usePracticeContext();
    return React.createElement(Stack, { className: "Actions" },
        React.createElement(SecondaryAction, { label: texts.actions.settings, disabled: true },
            React.createElement(SettingsIcon, null)),
        React.createElement(PrimaryAction, { label: texts.actions.play, onClick: startRecording },
            React.createElement(PlayArrowIcon, null)),
        React.createElement(SecondaryAction, { label: texts.actions.preview, onClick: startDemo },
            React.createElement(VolumeUpIcon, null)));
}
function EvaluateActions() {
    const { actions: { startRecording, startDemo } } = usePracticeContext();
    return React.createElement(Stack, { className: "Actions" },
        React.createElement(SecondaryAction, { label: texts.actions.settings, disabled: true },
            React.createElement(SettingsIcon, null)),
        React.createElement(PrimaryAction, { label: texts.actions.play, onClick: startRecording },
            React.createElement(PlayArrowIcon, null)),
        React.createElement(SecondaryAction, { label: texts.actions.preview, disabled: true, onClick: startDemo },
            React.createElement(VolumeUpIcon, null)));
}
function SecondaryAction(props) {
    return React.createElement(LabeledButton, { ...props, className: "SecondaryAction", variant: "secondary-action", size: "small" });
}
function PrimaryAction(props) {
    return React.createElement(LabeledButton, { ...props, variant: "primary-action", className: "PrimaryAction", size: "large" });
}
//# sourceMappingURL=Actions.js.map